import { render, staticRenderFns } from "./Bom.vue?vue&type=template&id=e3f994f2&scoped=true"
import script from "./Bom.vue?vue&type=script&lang=js"
export * from "./Bom.vue?vue&type=script&lang=js"
import style0 from "./Bom.vue?vue&type=style&index=0&id=e3f994f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3f994f2",
  null
  
)

export default component.exports